// extracted by mini-css-extract-plugin
module.exports = {"root":"root-StHnl","leftBlock":"leftBlock-3MG7s","icon":"icon-5xNLZ","title":"title-1EjAc","value":"value-1kE_a","loader":"loader-3QnQT","loading":"loading-2OVYu"};